export type CatalogDefaultRanking = {
  id: string;
  name: string;
  description: string;
  forWhom: string;
  category: 'dividendos' | 'liquidez' | 'patrimonio' | 'valor' | 'selic' | 'alavancagem';
  sort: string;
  catalogPath: '/catalogo';
  queryString?: string;
};

export const CATALOG_DEFAULT_RANKINGS: CatalogDefaultRanking[] = [
  {
    id: 'ranking-dy12m-maior',
    name: 'Maiores DY 12m',
    description: 'Ranking dos fundos com maior dividend yield acumulado em 12 meses.',
    forWhom: 'Quem busca renda mensal e quer comparar os maiores pagadores do momento.',
    category: 'dividendos',
    sort: 'dy12mPct:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-patrimonio-maior',
    name: 'Maior patrimônio',
    description: 'Ranking dos fundos com maior patrimônio líquido.',
    forWhom: 'Quem quer priorizar fundos com escala patrimonial mais alta.',
    category: 'patrimonio',
    sort: 'patrimonioLiquido:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-liquidez30d-maior',
    name: 'Maior liquidez 30d',
    description: 'Ranking dos fundos com maior liquidez média diária nos últimos 30 dias.',
    forWhom: 'Quem prioriza facilidade de entrada e saída de posição.',
    category: 'liquidez',
    sort: 'liquidezDiaria30d:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-pvp-menor',
    name: 'Menor P/VP',
    description: 'Ranking dos fundos negociados com menor relação preço/valor patrimonial.',
    forWhom: 'Quem busca ativos com maior desconto patrimonial.',
    category: 'valor',
    sort: 'currentPvp:asc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-vp-crescimento-12m-maior',
    name: 'Maior crescimento VP/cota (12m)',
    description: 'Ranking dos fundos com maior crescimento do valor patrimonial por cota em 12 meses.',
    forWhom: 'Quem quer comparar evolução patrimonial recente por cota.',
    category: 'patrimonio',
    sort: 'vpPerShareGrowth12mPct:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-distancia-maxima-maior',
    name: 'Mais distantes da máxima (12m)',
    description: 'Ranking dos fundos mais afastados da máxima de preço dos últimos 12 meses.',
    forWhom: 'Quem quer mapear possíveis casos de recuperação.',
    category: 'valor',
    sort: 'distanceTo12mHighPct:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-selic-sensibilidade-maior',
    name: 'Maior sensibilidade à Selic',
    description: 'Ranking dos fundos mais sensíveis ao ciclo de juros.',
    forWhom: 'Quem busca posições mais táticas para cenários de juros.',
    category: 'selic',
    sort: 'selicSensitivityScore:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-selic-sensibilidade-menor',
    name: 'Menor sensibilidade à Selic',
    description: 'Ranking dos fundos menos sensíveis ao ciclo de juros.',
    forWhom: 'Quem quer reduzir dependência da carteira ao cenário de Selic.',
    category: 'selic',
    sort: 'selicSensitivityScore:asc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-alavancagem-maior',
    name: 'Maior alavancagem',
    description: 'Ranking dos fundos com maior índice de alavancagem.',
    forWhom: 'Quem quer mapear exposição financeira mais agressiva.',
    category: 'alavancagem',
    sort: 'leverageIndexScore:desc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-vacancia-menor',
    name: 'Menor vacância',
    description: 'Ranking dos fundos com menor vacância média.',
    forWhom: 'Quem quer reduzir risco de perda de receita por imóveis vagos.',
    category: 'valor',
    sort: 'vacanciaPct:asc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-inadimplencia-menor',
    name: 'Menor inadimplência',
    description: 'Ranking dos fundos com menor inadimplência média.',
    forWhom: 'Quem quer foco em previsibilidade de recebíveis.',
    category: 'valor',
    sort: 'inadimplenciaPct:asc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-alavancagem-menor',
    name: 'Menor alavancagem',
    description: 'Ranking dos fundos com menor índice de alavancagem.',
    forWhom: 'Quem prefere estruturas de capital mais conservadoras.',
    category: 'alavancagem',
    sort: 'leverageIndexScore:asc',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-tijolo-menor-concentracao',
    name: 'Tijolo com menor concentração em tijolo',
    description: 'Dentro de FIIs de tijolo, mostra os fundos menos concentrados em tijolo.',
    forWhom: 'Quem quer identificar fundos de tijolo mais híbridos ou diversificados na prática.',
    category: 'valor',
    sort: 'concentracaoTijoloPct:asc',
    queryString: 'classificacao=TIJOLO',
    catalogPath: '/catalogo',
  },
  {
    id: 'ranking-papel-menor-concentracao',
    name: 'Papel com menor concentração em papel',
    description: 'Dentro de FIIs de papel, mostra os fundos menos concentrados em papel.',
    forWhom: 'Quem quer comparar fundos de papel com composição menos concentrada.',
    category: 'valor',
    sort: 'concentracaoPapelPct:asc',
    queryString: 'classificacao=PAPEL',
    catalogPath: '/catalogo',
  },
];
